const FETCH_PAYMENTS_STATS_START = 'FETCH_PAYMENTS_STATS_START';
const FETCH_PAYMENTS_STATS_SUCCESS = 'FETCH_PAYMENTS_STATS_SUCCESS';
const FETCH_PAYMENTS_STATS_ERROR = 'FETCH_PAYMENTS_STATS_ERROR';

export {
  FETCH_PAYMENTS_STATS_START,
  FETCH_PAYMENTS_STATS_SUCCESS,
  FETCH_PAYMENTS_STATS_ERROR,
};
